var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-wrap boxed-container"},[_c('Header'),_c('main',[_c('TopBanner'),_c('TypeMarquee'),_c('Features'),_c('Pricing')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }